import { formatDate, toMoment } from '../../../utils/dateFormat';

export const parseCommunityChatMessageDate = (value) => {
  const parsed = toMoment(value);
  return parsed ? parsed.toDate() : null;
};

export const getLocalDayKey = (date) => {
  const parsed = toMoment(date);
  return parsed ? parsed.format('YYYY-MM-DD') : null;
};

/** Today / Yesterday / weekday date label for chat dividers. */
export const formatCommunityChatDateDividerLabel = (date, now = new Date()) => {
  const message = toMoment(date);
  const current = toMoment(now);
  if (!message || !current) return '';

  const messageKey = message.format('YYYY-MM-DD');
  const todayKey = current.format('YYYY-MM-DD');

  if (messageKey === todayKey) {
    return 'Today';
  }

  if (messageKey === current.clone().subtract(1, 'day').format('YYYY-MM-DD')) {
    return 'Yesterday';
  }

  const sameYear = message.year() === current.year();
  return formatDate(message, sameYear ? 'dddd, MMM D' : 'dddd, MMM D, YYYY');
};

/** Insert date divider rows before the first message of each day. */
export const buildCommunityChatTimeline = (messages = []) => {
  const timeline = [];
  let previousDayKey = null;

  messages.forEach((message) => {
    const date = parseCommunityChatMessageDate(message.time);
    const dayKey = date ? getLocalDayKey(date) : null;

    if (dayKey && dayKey !== previousDayKey) {
      timeline.push({
        kind: 'divider',
        id: `divider-${dayKey}`,
        label: formatCommunityChatDateDividerLabel(date),
      });
      previousDayKey = dayKey;
    }

    timeline.push({ kind: 'message', ...message });
  });

  return timeline;
};
